import React from "react";
import Toggle from "../../../../Components/Atoms/Toggle";
export interface ToggleSwitchProps {
  labelText: string;
  checkedValue: boolean;
  onChangeHandler: (checked: boolean) => void;
  isLoading: boolean;
  description: string;
  disabled?: boolean;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  labelText,
  checkedValue,
  onChangeHandler,
  isLoading,
  description,
  disabled
}) => {
  return (
    <div
      className={`${
        checkedValue ? "bg-panache border-apple" : "bg-white-smoke border"
      } rounded border p-3 my-2 ${disabled ? "opacity-50" : ""}`}
    >
      <div className="font-semibold mb-4 flex items-center justify-between">
        <label className="mr-3">{labelText}</label>
        <Toggle
          checked={checkedValue}
          onChange={onChangeHandler}
          isLoading={isLoading}
          disabled={disabled}
        />
      </div>
      {description}
    </div>
  );
};

export default ToggleSwitch;
